import clsx from 'clsx';
import { FormControl, RadioGroup, FormControlLabel, Radio, makeStyles } from '@material-ui/core';

export const VOLUME = 'volume';
export const RATE = 'rate';
export const UTIL = 'util';

export const useStyles = makeStyles({
    root: {
        padding: 0,
        margin: 0,
        display: 'flex',
    },
    radioGroup: {
        justifyContent: 'flex-end',
    },
});

export default function VolumeRateUtilForm({ value, onChangeType, className, utilName = 'Utilization' }) {
    const classes = useStyles();
    return (
        <FormControl className={classes.root} component="fieldset">
            <RadioGroup
                className={clsx(classes.radioGroup, className)}
                row
                aria-label="type-of-chart"
                name="type-of-chart"
                value={value}
                onChange={(ev) => {
                    onChangeType(ev.target.value);
                }}
            >
                <FormControlLabel value={VOLUME} control={<Radio />} label="Volume" />
                <FormControlLabel value={RATE} control={<Radio />} label="Rate" />
                <FormControlLabel value={UTIL} control={<Radio />} label={utilName} />
            </RadioGroup>
        </FormControl>
    );
}
